function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import Dexie from "dexie";
/**
 * Accesses the central IndexedDB used by the `esm-offline` module to persist offline related state.
 * Leverages the `dexie` library for IndexedDB management.
 */ export class OfflineDb extends Dexie {
    constructor(){
        super('EsmOffline'), /**
   * The table used to store the data of the offline synchronization queue (aka "sync queue" / "offline actions").
   */ _define_property(this, "syncQueue", void 0), _define_property(this, "dynamicOfflineData", void 0);
        this.version(4).stores({
            syncQueue: '++id,userId,type,[userId+type]',
            dynamicOfflineData: '++id,type,identifier,*users,&[type+identifier]'
        });
        this.syncQueue = this.table('syncQueue');
        this.dynamicOfflineData = this.table('dynamicOfflineData');
    }
}
/**
 * @internal Temporarily added for esm-offline-tools-app and workarounds. Please don't use elsewhere.
 * @deprecated Should/Will be removed in the future per the above reason.
 */ export function getOfflineDb() {
    return new OfflineDb();
}
